module.exports = __webpack_public_path__ + "static/media/appLogoBig.1d9f7199.png";